//4、双吊轮孔列
import makerjs from "makerjs";
// inputParam,model,this.myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function HangWheelHoleTwoCol(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,X=inputParam.X,H=inputParam.H,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
   d = D*1*myZoom,
   h = H*1*myZoom,
    x0 = X*1*myZoom,
    y0 = Y*1*myZoom;
    if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              }
   //d = D*1,
  // h = H*1,
   if(d!==0){
      var TxtD="∮"+D;
     }
   if(h!==0){
    var TxtH=H;
   }
   if(x0!==0){          
   var TxtX=X;
   }
   if(y0!==0){          
    var TxtY=Y;
   }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(area==4){
//画孔 A位置孔
      //标记双吊轮孔列 A位置孔左
      var myHwhtcHolesAlf= new makerjs.models.Holes(d/2, [[xa, ya]]);
      var myHwhtcHolesMarkAlf = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkAlf.origin = [xa, ya];      
      var myHwhtcXMarkAlf = new makerjs.models.Square(0);      
      myHwhtcXMarkAlf.origin =[xa, ya];      
      var myHwhtcYMarkAlf = new makerjs.models.Square(0);      
      myHwhtcYMarkAlf.origin = [xa, ya];
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAlf, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkAlf, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtcHolesMarkAlf, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkAlf, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAlf, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkAlf, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtcXMarkAlf, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkAlf, TxtX, [-x0,y0+markShiftThree], [0, y0+markShiftThree]);//X文字标注
/*****************************************************************************/     
makerjs.model.addPath(myHwhtcYMarkAlf, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkAlf, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
/*****************************************************************************/ 
      //标记双吊轮孔列 A位置孔右
      var myHwhtcHolesArt= new makerjs.models.Holes(d/2, [[xa+h, ya]]);
      var myHwhtcHolesMarkArt = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkArt.origin = [xa+h, ya];      
      var myHwhtcXMarkArt = new makerjs.models.Square(0);      
     myHwhtcXMarkArt.origin =[xa+h, ya];      
      var myHwhtcYMarkArt = new makerjs.models.Square(0);      
      myHwhtcYMarkArt.origin = [xa+h, ya];  
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkArt, new makerjs.paths.Line([0,0], [0, 0+y0+markShiftThree]));//从孔圆心出发Y方向横向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkArt, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkArt, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
//makerjs.model.addPath(myHwhtcXMarkArt, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcYMarkArt, new makerjs.paths.Line([0, 0], [-h,0]));//H短标线    
makerjs.model.addPath(myHwhtcYMarkArt, new makerjs.paths.Line([0, y0+markShift], [-h,y0+markShift]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkArt, TxtH, [-h,y0+markShiftThree], [0,y0+markShiftThree]);//H文字标注
/*****************************************************************************/
 //标记双吊轮孔列 G位置孔左
     var myHwhtcHolesGlf= new makerjs.models.Holes(d/2, [[xg, yg]]);
      var myHwhtcHolesMarkGlf = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkGlf.origin = [xg, yg];      
      var myHwhtcXMarkGlf = new makerjs.models.Square(0);      
      myHwhtcXMarkGlf.origin = [xg, yg];      
      var myHwhtcYMarkGlf = new makerjs.models.Square(0);      
      myHwhtcYMarkGlf.origin = [xg, yg];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcXMarkGlf, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
makerjs.model.addPath(myHwhtcXMarkGlf, new makerjs.paths.Line([0,0], [-x0, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkGlf, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkGlf, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcXMarkGlf, new makerjs.paths.Line([0,0], [-x0,0]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkGlf, TxtX, [-x0, -markShift], [0,-markShift]);//X文字标注
/*****************************************************************************/    
makerjs.model.addPath(myHwhtcYMarkGlf, new makerjs.paths.Line([0,0], [0, -y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkGlf, TxtY, [-markShift, -y0], [-markShift,0]);//Y文字标注
/*****************************************************************************/ 
//标记双吊轮孔列 G位置孔右
  var myHwhtcHolesGrt= new makerjs.models.Holes(d/2, [[xg+h, yg]]);
      var myHwhtcHolesMarkGrt = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkGrt.origin = [xg+h, yg];  
      var myHwhtcYMarkGrt = new makerjs.models.Square(0);      
      myHwhtcYMarkGrt.origin = [xg+h, yg];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcYMarkGrt, new makerjs.paths.Line([0,0], [-h, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkGrt, new makerjs.paths.Line([0,0], [d,d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkGrt, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcYMarkGrt, new makerjs.paths.Line([-h,0], [0, 0]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkGrt, TxtH, [-h,0-markShift], [0, 0-markShift]);//H文字标注
/*****************************************************************************/
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoCol_Alf"+myHolesNum]=myHwhtcHolesAlf;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_Alf"+myHolesNum]=myHwhtcHolesAlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_Alf"+myHolesNum]=myHwhtcHolesAlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkDAlf"+myHolesNum]=myHwhtcHolesMarkAlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkDAlf"+myHolesNum]=myHwhtcXMarkAlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkDAlf"+myHolesNum]=myHwhtcYMarkAlf;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_Art"+myHolesNum]=myHwhtcHolesArt;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_Art"+myHolesNum]=myHwhtcHolesArt;
markers.models["TypeHoles_HangWheelHoleTwoCol_Art"+myHolesNum]=myHwhtcHolesArt;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkDArt"+myHolesNum]=myHwhtcHolesMarkArt;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkDArt"+myHolesNum]=myHwhtcYMarkArt;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_Glf"+myHolesNum]=myHwhtcHolesGlf;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_Glf"+myHolesNum]=myHwhtcHolesGlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_Glf"+myHolesNum]=myHwhtcHolesGlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkDGlf"+myHolesNum]=myHwhtcHolesMarkGlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkDGlf"+myHolesNum]=myHwhtcXMarkGlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkDGlf"+myHolesNum]=myHwhtcYMarkGlf; 
/*****************************************************************************/ 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_Grt"+myHolesNum]=myHwhtcHolesGrt;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_Grt"+myHolesNum]=myHwhtcHolesGrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_Grt"+myHolesNum]=myHwhtcHolesGrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkDGrt"+myHolesNum]=myHwhtcHolesMarkGrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkDGrt"+myHolesNum]=myHwhtcYMarkGrt; 
/*****************************************************************************/ 
  }
  else if(area==6){
//画孔 C位置孔
      //标记双吊轮孔列 C位置孔左
      var myHwhtcHolesClf= new makerjs.models.Holes(d/2, [[xc, yc]]);
      var myHwhtcHolesMarkClf = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkClf.origin = [xc, yc];      
      var myHwhtcXMarkClf = new makerjs.models.Square(0);      
      myHwhtcXMarkClf.origin =[xc, yc];      
      var myHwhtcYMarkClf = new makerjs.models.Square(0);      
      myHwhtcYMarkClf.origin = [xc, yc];
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkClf, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//Y轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkClf, new makerjs.paths.Line([0,0], [x0+markShiftThree, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtcHolesMarkClf, new makerjs.paths.Line([x0,y0], [x0+markShiftThree, y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkClf, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkClf, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkClf, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtcXMarkClf, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkClf, TxtX, [0,y0+markShiftTwo], [x0, y0+markShiftTwo]);//X文字标注
/*****************************************************************************/     
makerjs.model.addPath(myHwhtcYMarkClf, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkClf, TxtY, [x0+markShiftThree,0], [x0+markShiftThree, y0]);//Y文字标注
/*****************************************************************************/ 
      //标记双吊轮孔列 C位置孔右
      var myHwhtcHolesCrt= new makerjs.models.Holes(d/2, [[xc-h, yc]]);
      var myHwhtcHolesMarkCrt = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkCrt.origin = [xc-h, yc];      
      var myHwhtcXMarkCrt = new makerjs.models.Square(0);      
     myHwhtcXMarkCrt.origin =[xc-h, yc];      
      var myHwhtcYMarkCrt = new makerjs.models.Square(0);      
      myHwhtcYMarkCrt.origin = [xc-h, yc];  
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCrt, new makerjs.paths.Line([0,0], [0, 0+y0+markShiftThree]));//从孔圆心出发Y方向横向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCrt, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkCrt, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcYMarkCrt, new makerjs.paths.Line([0, 0], [h,0]));//H短标线    
makerjs.model.addPath(myHwhtcYMarkCrt, new makerjs.paths.Line([0, y0+markShift], [h,y0+markShift]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkCrt, TxtH, [0,y0+markShiftTwo], [h,y0+markShiftTwo]);//H文字标注
/*****************************************************************************/
 //标记双吊轮孔列 I位置孔左
     var myHwhtcHolesIlf= new makerjs.models.Holes(d/2, [[xi, yi]]);
      var myHwhtcHolesMarkIlf = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkIlf.origin = [xi, yi];      
      var myHwhtcXMarkIlf = new makerjs.models.Square(0);      
      myHwhtcXMarkIlf.origin = [xi, yi];      
      var myHwhtcYMarkIlf = new makerjs.models.Square(0);      
      myHwhtcYMarkIlf.origin = [xi, yi];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcHolesMarkIlf, new makerjs.paths.Line([x0,0], [x0+markShiftTwo, 0]));//Y轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkIlf, new makerjs.paths.Line([x0,-y0], [x0+markShiftTwo, -y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcXMarkIlf, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
makerjs.model.addPath(myHwhtcXMarkIlf, new makerjs.paths.Line([0,0], [x0, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkIlf, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkIlf, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcXMarkIlf, new makerjs.paths.Line([0,0], [x0,0]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkIlf, TxtX, [0, -markShift], [x0,-markShift]);//X文字标注
/*****************************************************************************/    
makerjs.model.addPath(myHwhtcYMarkIlf, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, -y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkIlf, TxtY, [x0+markShiftThree, -y0], [x0+markShiftThree,0]);//Y文字标注
/*****************************************************************************/ 
//标记双吊轮孔列 I位置孔右
  var myHwhtcHolesIrt= new makerjs.models.Holes(d/2, [[xi-h, yi]]);
      var myHwhtcHolesMarkIrt = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkIrt.origin = [xi-h, yi];  
      var myHwhtcYMarkIrt = new makerjs.models.Square(0);      
      myHwhtcYMarkIrt.origin = [xi-h, yi];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcYMarkIrt, new makerjs.paths.Line([0,0], [h, 0]));////从孔圆心出发X方向竖向标线
makerjs.model.addPath(myHwhtcYMarkIrt, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkIrt, new makerjs.paths.Line([0,0], [d,d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkIrt, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/    
makerjs.model.addPath(myHwhtcYMarkIrt, new makerjs.paths.Line([h,0], [0, 0]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkIrt, TxtH, [0,0-markShift], [h, 0-markShift]);//H文字标注
/*****************************************************************************/
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoCol_FClf"+myHolesNum]=myHwhtcHolesClf;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_FClf"+myHolesNum]=myHwhtcHolesClf;
markers.models["TypeHoles_HangWheelHoleTwoCol_FClf"+myHolesNum]=myHwhtcHolesClf;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkFClf"+myHolesNum]=myHwhtcHolesMarkClf;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkFClf"+myHolesNum]=myHwhtcXMarkClf;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkFClf"+myHolesNum]=myHwhtcYMarkClf;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_FCrt"+myHolesNum]=myHwhtcHolesCrt;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_FCrt"+myHolesNum]=myHwhtcHolesCrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_FCrt"+myHolesNum]=myHwhtcHolesCrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkFCrt"+myHolesNum]=myHwhtcHolesMarkCrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkFCrt"+myHolesNum]=myHwhtcYMarkCrt;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_FIlf"+myHolesNum]=myHwhtcHolesIlf;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_FIlf"+myHolesNum]=myHwhtcHolesIlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_FIlf"+myHolesNum]=myHwhtcHolesIlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkFIlf"+myHolesNum]=myHwhtcHolesMarkIlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkFIlf"+myHolesNum]=myHwhtcXMarkIlf;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkFIlf"+myHolesNum]=myHwhtcYMarkIlf; 
/*****************************************************************************/ 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_FIrt"+myHolesNum]=myHwhtcHolesIrt;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_FIrt"+myHolesNum]=myHwhtcHolesIrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_FIrt"+myHolesNum]=myHwhtcHolesIrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkFIrt"+myHolesNum]=myHwhtcHolesMarkIrt;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkFIrt"+myHolesNum]=myHwhtcYMarkIrt; 
/*****************************************************************************/ 
  }
  else if(area==2){
//画孔 C位置孔
      //标记双吊轮孔列 C位置孔左
      var myHwhtcHolesCup= new makerjs.models.Holes(d/2, [[xc, yc]]);
      var myHwhtcHolesMarkCup = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkCup.origin = [xc, yc];      
      var myHwhtcXMarkCup = new makerjs.models.Square(0);      
      myHwhtcXMarkCup.origin =[xc, yc];      
      var myHwhtcYMarkCup = new makerjs.models.Square(0);      
      myHwhtcYMarkCup.origin = [xc, yc];
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCup, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//Y轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkCup, new makerjs.paths.Line([0,0], [x0+markShiftThree, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtcHolesMarkCup, new makerjs.paths.Line([x0,y0], [x0+markShiftThree, y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkCup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkCup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtcXMarkCup, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkCup, TxtX, [0,y0+markShiftTwo], [x0, y0+markShiftTwo]);//X文字标注
/*****************************************************************************/     
makerjs.model.addPath(myHwhtcYMarkCup, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkCup, TxtY, [x0+markShiftThree,0], [x0+markShiftThree, y0]);//Y文字标注
/*****************************************************************************/ 
      //标记双吊轮孔列 C位置孔右
      var myHwhtcHolesCdn= new makerjs.models.Holes(d/2, [[xc, yc-h]]);
      var myHwhtcHolesMarkCdn = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkCdn.origin = [xc, yc-h];      
      var myHwhtcXMarkCdn = new makerjs.models.Square(0);      
     myHwhtcXMarkCdn.origin =[xc, yc-h];      
      var myHwhtcYMarkCdn = new makerjs.models.Square(0);      
      myHwhtcYMarkCdn.origin = [xc, yc-h];  
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCdn, new makerjs.paths.Line([0,0], [x0+markShiftThree, 0]));//从孔圆心出发Y方向横向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkCdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkCdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcYMarkCdn, new makerjs.paths.Line([0, 0], [0,h]));//H短标线    
makerjs.model.addPath(myHwhtcYMarkCdn, new makerjs.paths.Line([x0+markShift, 0], [x0+markShift,h]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkCdn, TxtH, [x0+markShiftTwo, 0], [x0+markShiftTwo,h]);//H文字标注
/*****************************************************************************/
 //标记双吊轮孔列 I位置孔左
 var myHwhtcHolesAup= new makerjs.models.Holes(d/2, [[xa, ya]]);
 var myHwhtcHolesMarkAup = new makerjs.models.Square(0); //孔的原点       
 myHwhtcHolesMarkAup.origin = [xa, ya];      
 var myHwhtcXMarkAup = new makerjs.models.Square(0);      
 myHwhtcXMarkAup.origin =[xa, ya];      
 var myHwhtcYMarkAup = new makerjs.models.Square(0);      
 myHwhtcYMarkAup.origin = [xa, ya];
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkAup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtcHolesMarkAup, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcHolesMarkAup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkAup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtcXMarkAup, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkAup, TxtX, [-x0,y0+markShiftThree], [0, y0+markShiftThree]);//X文字标注
/*****************************************************************************/     
makerjs.model.addPath(myHwhtcYMarkAup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkAup, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
/*****************************************************************************/ 
 //标记双吊轮孔列 A位置孔右
 var myHwhtcHolesAdn= new makerjs.models.Holes(d/2, [[xa, ya-h]]);
 var myHwhtcHolesMarkAdn = new makerjs.models.Square(0); //孔的原点       
 myHwhtcHolesMarkAdn.origin = [xa, ya-h];      
 var myHwhtcXMarkAdn = new makerjs.models.Square(0);      
myHwhtcXMarkAdn.origin =[xa, ya-h];      
 var myHwhtcYMarkAdn = new makerjs.models.Square(0);      
 myHwhtcYMarkAdn.origin = [xa, ya-h];  
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAdn, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发Y方向横向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkAdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkAdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
//makerjs.model.addPath(myHwhtcXMarkAdn, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcYMarkAdn, new makerjs.paths.Line([0, 0], [0,h]));//H短标线    
makerjs.model.addPath(myHwhtcYMarkAdn, new makerjs.paths.Line([-x0-markShiftTwo, 0], [-x0-markShiftTwo,h]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkAdn, TxtH, [-x0-markShiftThree, 0], [-x0-markShiftThree,h]);//H文字标注
/*****************************************************************************/
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoCol_BCup"+myHolesNum]=myHwhtcHolesCup;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_BCup"+myHolesNum]=myHwhtcHolesCup;
markers.models["TypeHoles_HangWheelHoleTwoCol_BCup"+myHolesNum]=myHwhtcHolesCup;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkBCup"+myHolesNum]=myHwhtcHolesMarkCup;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkBCup"+myHolesNum]=myHwhtcXMarkCup;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkBCup"+myHolesNum]=myHwhtcYMarkCup;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_BCdn"+myHolesNum]=myHwhtcHolesCdn;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_BCdn"+myHolesNum]=myHwhtcHolesCdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_BCdn"+myHolesNum]=myHwhtcHolesCdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkBCdn"+myHolesNum]=myHwhtcHolesMarkCdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkBCdn"+myHolesNum]=myHwhtcYMarkCdn;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_BAup"+myHolesNum]=myHwhtcHolesAup;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_BAup"+myHolesNum]=myHwhtcHolesAup;
markers.models["TypeHoles_HangWheelHoleTwoCol_BAup"+myHolesNum]=myHwhtcHolesAup;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkBAup"+myHolesNum]=myHwhtcHolesMarkAup;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkBAup"+myHolesNum]=myHwhtcXMarkAup;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkBAup"+myHolesNum]=myHwhtcYMarkAup; 
/*****************************************************************************/ 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_BAdn"+myHolesNum]=myHwhtcHolesAdn;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_BAdn"+myHolesNum]=myHwhtcHolesAdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_BAdn"+myHolesNum]=myHwhtcHolesAdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkBAdn"+myHolesNum]=myHwhtcHolesMarkAdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkBAdn"+myHolesNum]=myHwhtcYMarkAdn; 
/*****************************************************************************/ 
  }
  else if(area==8){
//画孔 C位置孔
      //标记双吊轮孔列 C位置孔左
      
/*****************************************************************************/
 //标记双吊轮孔列 I位置孔左
     var myHwhtcHolesIup= new makerjs.models.Holes(d/2, [[xi, yi]]);
      var myHwhtcHolesMarkIup = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkIup.origin = [xi, yi];      
      var myHwhtcXMarkIup = new makerjs.models.Square(0);      
      myHwhtcXMarkIup.origin = [xi, yi];      
      var myHwhtcYMarkIup = new makerjs.models.Square(0);      
      myHwhtcYMarkIup.origin = [xi, yi];  
/*****************************************************************************/  
// makerjs.model.addPath(myHwhtcHolesMarkIup, new makerjs.paths.Line([x0,0], [x0+markShiftTwo, 0]));//Y轴加长标线
// makerjs.model.addPath(myHwhtcHolesMarkIup, new makerjs.paths.Line([x0,-y0], [x0+markShiftTwo, -y0]));//X轴加长标线
makerjs.model.addPath(myHwhtcXMarkIup, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
makerjs.model.addPath(myHwhtcXMarkIup, new makerjs.paths.Line([0,0], [x0, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkIup, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkIup, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcXMarkIup, new makerjs.paths.Line([0,0], [x0,0]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkIup, TxtX, [0, -markShift], [x0,-markShift]);//X文字标注
/*****************************************************************************/    
makerjs.model.addPath(myHwhtcYMarkIup, new makerjs.paths.Line([0,0], [0, -y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkIup, TxtY, [-markShift,-y0], [-markShift, 0]);//Y文字标注
/*****************************************************************************/ 
//标记双吊轮孔列 I位置孔右
  var myHwhtcHolesIdn= new makerjs.models.Holes(d/2, [[xi, yi+h]]);
      var myHwhtcHolesMarkIdn = new makerjs.models.Square(0); //孔的原点       
      myHwhtcHolesMarkIdn.origin = [xi, yi+h];  
      var myHwhtcYMarkIdn = new makerjs.models.Square(0);      
      myHwhtcYMarkIdn.origin = [xi, yi+h];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcYMarkIdn, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkIdn, new makerjs.paths.Line([0,0], [d,d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkIdn, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtcYMarkIdn, new makerjs.paths.Line([0,0], [0, -h]));////从孔圆心出发X方向竖向标线
makerjs.model.addCaption(myHwhtcYMarkIdn, TxtH, [-markShift,-h], [-markShift, 0]);//H文字标注
/*****************************************************************************/
/*****************************************************************************/ //标记双吊轮孔列 G位置孔左
     var myHwhtcHolesGup= new makerjs.models.Holes(d/2, [[xg, yg]]);
     var myHwhtcHolesMarkGup = new makerjs.models.Square(0); //孔的原点       
     myHwhtcHolesMarkGup.origin = [xg, yg];      
     var myHwhtcXMarkGup = new makerjs.models.Square(0);      
     myHwhtcXMarkGup.origin = [xg, yg];      
     var myHwhtcYMarkGup = new makerjs.models.Square(0);      
     myHwhtcYMarkGup.origin = [xg, yg];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtcXMarkGup, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
makerjs.model.addPath(myHwhtcXMarkGup, new makerjs.paths.Line([0,0], [-x0, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkGup, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkGup, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcXMarkGup, new makerjs.paths.Line([0,0], [-x0,0]));//X短标线
makerjs.model.addCaption(myHwhtcXMarkGup, TxtX, [-x0, -markShift], [0,-markShift]);//X文字标注
/*****************************************************************************/    
makerjs.model.addPath(myHwhtcYMarkGup, new makerjs.paths.Line([0,0], [0, -y0]));//Y短标线
makerjs.model.addCaption(myHwhtcYMarkGup, TxtY, [-markShift, -y0], [-markShift,0]);//Y文字标注
/*****************************************************************************/ 
//标记双吊轮孔列 G位置孔右
 var myHwhtcHolesGdn= new makerjs.models.Holes(d/2, [[xg, yg+h]]);
     var myHwhtcHolesMarkGdn = new makerjs.models.Square(0); //孔的原点       
     myHwhtcHolesMarkGdn.origin = [xg, yg+h];  
     var myHwhtcYMarkGdn = new makerjs.models.Square(0);      
     myHwhtcYMarkGdn.origin = [xg, yg+h];  
/*****************************************************************************/  
// makerjs.model.addPath(myHwhtcYMarkGdn, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcHolesMarkGdn, new makerjs.paths.Line([0,0], [d,d]));//直径标线
makerjs.model.addCaption(myHwhtcHolesMarkGdn, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtcYMarkGdn, new makerjs.paths.Line([0,0], [0, -h]));//H短标线
makerjs.model.addCaption(myHwhtcYMarkGdn, TxtH, [-markShift,-h], [-markShift, 0]);//H文字标注

/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_HIup"+myHolesNum]=myHwhtcHolesIup;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_HIup"+myHolesNum]=myHwhtcHolesIup;
markers.models["TypeHoles_HangWheelHoleTwoCol_HIup"+myHolesNum]=myHwhtcHolesIup;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkHIup"+myHolesNum]=myHwhtcHolesMarkIup;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkHIup"+myHolesNum]=myHwhtcXMarkIup;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkHIup"+myHolesNum]=myHwhtcYMarkIup; 
/*****************************************************************************/ 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_HIdn"+myHolesNum]=myHwhtcHolesIdn;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_HIdn"+myHolesNum]=myHwhtcHolesIdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_HIdn"+myHolesNum]=myHwhtcHolesIdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkHIdn"+myHolesNum]=myHwhtcHolesMarkIdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkHIdn"+myHolesNum]=myHwhtcYMarkIdn; 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_HGup"+myHolesNum]=myHwhtcHolesGup;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_HGup"+myHolesNum]=myHwhtcHolesGup;
markers.models["TypeHoles_HangWheelHoleTwoCol_HGup"+myHolesNum]=myHwhtcHolesGup;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkHGup"+myHolesNum]=myHwhtcHolesMarkGup;
markers.models["TypeHoles_HangWheelHoleTwoCol_XMarkHGup"+myHolesNum]=myHwhtcXMarkGup;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkHGup"+myHolesNum]=myHwhtcYMarkGup; 
/*****************************************************************************/ 
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoCol_HGdn"+myHolesNum]=myHwhtcHolesGdn;
cutPlate.models["TypeHoles_HangWheelHoleTwoCol_HGdn"+myHolesNum]=myHwhtcHolesGdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_HGdn"+myHolesNum]=myHwhtcHolesGdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_MarkHGdn"+myHolesNum]=myHwhtcHolesMarkGdn;
markers.models["TypeHoles_HangWheelHoleTwoCol_YMarkHGdn"+myHolesNum]=myHwhtcYMarkGdn; 
/*****************************************************************************/  
  }


myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default HangWheelHoleTwoCol;